import PropTypes from 'prop-types'
import { cn } from 'lib/utils'

export const AdasListItemText = ({ children, primary, secondary, className, disableTypography, sx, ...props }) => (
  <span className={cn('flex flex-col flex-1 min-w-0', className)} {...props}>
    {disableTypography ? (
      children
    ) : (
      <>
        {primary && <span className='text-sm font-medium text-text-primary truncate'>{primary}</span>}
        {secondary && <span className='text-xs text-text-secondary truncate'>{secondary}</span>}
        {children}
      </>
    )}
  </span>
)

AdasListItemText.propTypes = {
  children: PropTypes.node,
  primary: PropTypes.node,
  secondary: PropTypes.node,
  className: PropTypes.string,
  disableTypography: PropTypes.bool
}
